<ng-template #loadingTemplate>
    <i class="fa fa-spinner fa-spin"></i>
</ng-template>
<div id="burdens" class="card" [style]="{ height: '72vh', 'min-height': '72vh' }">
    <div style="padding-bottom: 1vh;">
        <!-- <ef-column-search [elements]="elements"></ef-column-search> -->
    </div>

    <p-table stripedRows #dataTable [value]="clonedBurdens" dataKey="id" editMode="row" (onRowSelect)="onRowSelect($event)"
        [(selection)]="selected" [rows]="100" [columns]="cols" sortMode="multiple" exportFilename="burdens"
        [exportFunction]="onExport" [scrollable]="true" scrollHeight="65vh">
        <ng-template pTemplate="emptymessage">
            <tr>
                <td style="text-align: center; width: 100%;">
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
            <tr>
                <td colspan="21" style="text-align: center">
                    <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header let-item let-columns>
            <!-- column headers -->
            <tr>
                <!-- Status-->
                <th pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                    <i class="pi pi-exclamation-circle"></i>
                </th>
                <!-- Contract -->
                <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="ContractDesc">
                    Contract
                    <p-sortIcon field="ContractDesc" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    <p-columnFilter field="ContractListID" matchMode="in" display="menu" [showMatchModes]="false"
                        [showOperator]="false" [showAddButton]="false" class="ml-auto">
                        <ng-template #filter let-value let-filter="filterCallback">
                            <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                [options]="contracts" [filter]="true" styleClass="w-full" [ngModel]="value"
                                (ngModelChange)="filter($event)"></p-multiSelect>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <!-- Charge Number -->
                <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="ChargeNumber">
                    Charge Number
                    <p-sortIcon field="ChargeNumber" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    <p-columnFilter field="ChargeNumber" matchMode="in" display="menu" [showMatchModes]="false"
                        [showOperator]="false" [showAddButton]="false" class="ml-auto">
                        <ng-template #filter let-value let-filter="filterCallback">
                            <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                [options]="chargeNumbers" [filter]="true" styleClass="w-full" [ngModel]="value"
                                (ngModelChange)="filter($event)"></p-multiSelect>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <!-- Contract Type -->
                <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="ContractType">
                    Contract Type
                    <p-sortIcon field="ContractType" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                    <p-columnFilter field="ContractType" matchMode="in" display="menu" [showMatchModes]="false"
                        [showOperator]="false" [showAddButton]="false" class="ml-auto">
                        <ng-template #filter let-value let-filter="filterCallback">
                            <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                                [options]="contractTypes" [filter]="true" styleClass="w-full" [ngModel]="value"
                                (ngModelChange)="filter($event)"></p-multiSelect>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <!-- dynamic -->
                <th *ngFor="let col of columns" [style]="col.style">
                    {{ col.header }}
                </th>
            </tr>
        </ng-template>
        <ng-template #body let-item let-edit="editing" let-ri="rowIndex" let-columns="columns">
            <tr data-id="row-{{ item.id }}" [pSelectableRow]="item" [pEditableRow]="item">
                <!-- Status-->
                <td pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                    <div (click)="onStatusClick(item)">
                        <ef-status-icon [status]="item?.Status?.StatusCode"
                            [message]="item?.Status?.Message"></ef-status-icon>
                    </div>
                </td>
                <!-- Contract -->
                <td pFrozenColumn [frozen]="IsColumnFrozen" [attr.title]="item.ContractDesc">
                    {{ item.ContractDesc }}
                </td>
                <!-- Charge Number -->
                <td pFrozenColumn [frozen]="IsColumnFrozen" [attr.title]="item.ChargeNumber">
                    {{ item.ChargeNumber }}
                </td>
                <!-- Contract Type -->
                <td pFrozenColumn [frozen]="IsColumnFrozen" [attr.title]="item.ContractType">
                    {{ item.ContractType }}
                </td>
                <!-- dynamic -->
                <td *ngFor="let col of columns" [style]="col.style">
                    <!-- <ef-checkbox [rowData]="item" [property]="[col.group][col.field]"></ef-checkbox> -->
                    <input type="checkbox" [(ngModel)]="item[col.group][col.field]"
                        [ngModelOptions]="{ standalone: true }"
                        [name]="item.id + '-' + col.group + '-' + col.field"
                        (click)="checkboxChanged($event, item, col.group, col.field)" [disabled]="item.IsReadOnly">
                    <!-- <p-checkbox
                        *ngIf="!item[col.group].loading; else loadingTemplate"
                        [disabled]="item.IsReadOnly"
                        binary="true"
                        type="checkbox"
                        [(ngModel)]="item[col.group][col.field]"
                        [name]="item.SettingType"
                        (onChange)="
                            checkboxChanged($event, item, col.group, col.field)
                        "
                    ></p-checkbox> -->
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
